import { initState } from "../../pages/common/sign-in/profile-config/constants";
import { apiInitState, reducerApiConstructor } from "../helpers";

const apiReducers = reducerApiConstructor("main");

export const mainInitState = {
  init: false,
  user: {
    email: null,
    name: null,
    surname: null,
    university: null,
    investigationGroup: [],
    investigationLines: [],
    profilePicture: null,
    attachments: [],
    chats: [],
  },
  api: apiInitState,
};

export const mainReducers = {
  init: (state, { payload }) => {
    // user
    state.user.email = payload.email;
    state.user.name = payload.name;
    state.user.surname = payload.surname;
    state.user.university = payload.university;
    state.user.investigationGroup = payload.investigationGroup;
    state.user.profilePicture = payload.profilePicture;
    state.user.chats = payload.chats;

    state.user.attachments = payload.attachments;

    // init
    state.init = true;
  },

  // user control
  signInWithEmail: (state, { payload }) => {
    state.api.loading = true;
    state.api.type = payload.type;
  },

  signInWithGoogle: (state, action) => {},

  logInEmail: (state, action) => {
    state.api.loading = true;
    state.api.type = action.type;
  },

  logOutUser: (state, action) => {
    state = initState;
  },

  initUserInfoDatabase: (state, action) => {
    state.api.loading = true;
    state.api.type = action.type;
  },

  fetchUserInfo: (state, action) => {},

  uploadProfileImage: (state, action) => {},

  updateProfilePicture: (state, { payload }) => {
    state.user.profilePicture = payload;
  },

  uploadFile: (state, action) => {},

  setUploadedFiles: () => {},

  failUploadingImage: (state) => {},

  ...apiReducers,
};
